module.exports = __webpack_public_path__ + "static/media/greenhouse3DModel1.10ce6a70.png";